import type {ReactElement} from 'react';
import React from 'react';
import {BaseTextOutlineOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-text-outline-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

interface ItemOutlineOptionProps {
  onClickColorFill(): void;
}

export function TextOutlineOption({...props}: ItemOutlineOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const gitype = useGetKeyFromActiveItem('gitype');
  const stroke = useGetKeyFromTextStylesActiveItem('stroke');
  const strokeWidth = useGetKeyFromTextStylesActiveItem('strokeWidth');
  const strokeColor = useGetKeyFromTextStylesActiveItem('strokeColor');
  const scaleX = useGetKeyFromActiveItem('scaleX');
  const isBold = useGetKeyFromTextStylesActiveItem('isBold');
  const isBold2 = useGetKeyFromTableItem('isBold2');

  if (!activeItem || (activeItem && !('textStyles' in activeItem)) || !gitype || stroke === undefined || scaleX === undefined || strokeWidth === undefined || !strokeColor) {
    throw new Error('Item does not have text styles attribtue');
  }

  const onClickColorFill = (): void => {
    props.onClickColorFill();
  };

  const onToggleOutlineOption = (): void => {
    void activeItem.updateFromObject({
      textStyles: {
        stroke: !stroke,
        strokeWidth: activeItem.textStyles.getDefaultStrokeWidth(gitype, scaleX),
        strokeColor: activeItem.textStyles.getColorForStroke(),
      },
    });
  };

  const updateStrokeThickness = (strokeWidth: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        textStyles: {
          strokeWidth,
        },
      },
      {
        undoable,
      }
    );
  };

  const isOutlineDisabled = (): boolean => {
    return activeItem.isOutlineDisabled();
  };

  return (
    <BaseTextOutlineOption
      key={`${String(isBold)}-${String(isBold2)}`}
      stroke={stroke}
      isDisabled={isOutlineDisabled()}
      strokeWidth={strokeWidth}
      strokeColor={strokeColor}
      onToggleOutlineOption={onToggleOutlineOption}
      updateStrokeThickness={updateStrokeThickness}
      onClickColorFill={onClickColorFill}
    />
  );
}
